import { render, staticRenderFns } from "./MlwSendCoupon.vue?vue&type=template&id=c8434a96&scoped=true"
import script from "./MlwSendCoupon.vue?vue&type=script&lang=js"
export * from "./MlwSendCoupon.vue?vue&type=script&lang=js"
import style0 from "./MlwSendCoupon.vue?vue&type=style&index=0&id=c8434a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8434a96",
  null
  
)

export default component.exports